import type { ComponentEnvelope } from '@care-companion/protocol';
import { CareCompanionReceptionButton } from './care_companion_reception_button.component';

export function CareCompanionMessageComponent({ component }: { component: ComponentEnvelope }): JSX.Element | null {
	switch (component.type) {
		case 'com.visibacare.reception-button':
			return <CareCompanionReceptionButton component={component} />;
		default:
			return component.fallbackText == null ? null : <>{component.fallbackText}</>;
	}
}
